import "./IconEdLOSGroup.scss";
import { ReactComponent as EdLOSGroupIcon } from "./svg/edLosGroup.svg";

interface Props {
  className?: string;
}

export const IconEdLOSGroup = ({ className = "" }: Props) => {
  return (
    <span className={`IconEdLOSGroup ${className}`}>
      <EdLOSGroupIcon />
    </span>
  );
};
